import { render } from "./CateringBody.vue?vue&type=template&id=42a4e49a"
import script from "./CateringBody.vue?vue&type=script&lang=js"
export * from "./CateringBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__